import { useQuery } from "@tanstack/react-query"

import type { FormColumn } from "../schemas/column-schema"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

export type Template = {
  id: string
  title: string
  columns: FormColumn[]
  type: "personal" | "company"
}

function getTemplates(): Promise<Template[]> {
  return api.get("/parser/list-templates")
}

export function useTemplatesQuery() {
  return useQuery({
    queryKey: queryKeys.parserTemplates(),
    queryFn: getTemplates,
  })
}
